<div class="settings-page">
    <div class="content-box">

        <div class="row">
            <div class="col-sm-12 settings-page__content">
                <div class="settings-card">
                    <div class="settings-card__header">
                        <img src="/assets/images/Group 24.svg" alt="" />
                        <div class="settings-card__header-headline">
                            <h4>AWB-uri</h4>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-sm-12">
                <div class="section">
                    <div class="section-top">
                        <h3 class="section-title">AWB-uri</h3>
                        <div class="section-top-actions">
                            <button type="button" class="btn btn-sm btn-info pull-right ms-1"
                                (click)="rerenderDT(false)">
                                <i class="fa-solid fa-arrows-rotate"></i>
                            </button>
                            <button
                                *ngIf="permissionsService.hasPermission('indoc-module.settings.posta-awb.download-csvs')"
                                type="button" class="btn btn-sm btn-warning pull-right ms-1" (click)="downloadCSV()">
                                <i class="fa fa-download"></i>
                                CSV
                            </button>
                            <button
                                *ngIf="permissionsService.hasPermission('indoc-module.settings.posta-awb.download-pdf')"
                                type="button" class="btn btn-sm btn-primary pull-right ms-1" (click)="downloadPDF()">
                                <i class="fa fa-download"></i>
                                PDF
                            </button>
                        </div>
                    </div>

                    <div class="card-container p-2" *ngIf="showCard">
                        <form [formGroup]="searchParamsForm">
                            <div class="divider-container mb-2">
                                <div class="line"></div>
                                <span class="text">CĂUTARE DOCUMENTE - PUNCTUAL</span>
                                <div class="line"></div>
                            </div>

                            <div class="row">
                                <div class="col-md-6">
                                    <mat-form-field class="w-100">
                                        <mat-label>Număr AWB</mat-label>
                                        <input matInput type="string" formControlName="awb" />
                                    </mat-form-field>
                                </div>

                                <div class="col-md-6">
                                    <mat-form-field class="w-100">
                                        <mat-label>Borderou</mat-label>
                                        <input matInput type="number" formControlName="borderou" />
                                    </mat-form-field>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-md-6">
                                    <mat-form-field class="w-100">
                                        <mat-label>Document principal</mat-label>
                                        <input matInput type="number" formControlName="document" />
                                    </mat-form-field>
                                </div>

                                <div class="col-md-6">
                                    <mat-form-field class="w-100">
                                        <mat-label>Destinatar</mat-label>
                                        <mat-select formControlName="destinatar">
                                            <mat-form-field class="px-2 w-100 sticky-input">
                                                <input matInput [formControl]="destinatariControl"
                                                    (keydown)="$event.stopPropagation()"
                                                    (click)="$event.stopPropagation()" />
                                            </mat-form-field>

                                            <mat-option *ngIf="showDestinatariMessage" disabled>
                                                <span
                                                    *ngIf="!destinatariControl.value || destinatariControl.value.length < 2">
                                                    Vă rugăm să introduceți 2 caractere sau mai multe
                                                </span>
                                                <span
                                                    *ngIf="isDestinatariLoading && destinatariControl.value.length >= 2">
                                                    Se caută...
                                                </span>
                                                <span
                                                    *ngIf="!isDestinatariLoading && destinatariLoadComplete && destinatari.length === 0 && destinatariControl.value && destinatariControl.value.length >= 2">
                                                    Nu s-au găsit rezultate
                                                </span>
                                            </mat-option>

                                            <mat-option *ngFor="let destinatar of destinatari" [value]="destinatar.id">
                                                {{ destinatar.denumire }}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-md-6">
                                    <mat-form-field>
                                        <mat-label>Status</mat-label>
                                        <mat-select formControlName="status">
                                            <mat-option *ngFor="let param of statusParameters" [value]="param.value">
                                                {{ param.key }}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                            </div>

                            <div class="divider-container mb-2">
                                <div class="line"></div>
                                <span class="text">CĂUTARE DOCUMENTE - INSTITUȚIE/SERVICIU/OPERATOR</span>
                                <div class="line"></div>
                            </div>

                            <div class="row">
                                <div class="col-md-12">
                                    <mat-form-field appearance="fill">
                                        <mat-label>Instituție/Direcție</mat-label>
                                        <mat-select formControlName="id_directie"
                                            (openedChange)="onDirectieSelectClosed()"
                                            (selectionChange)="onDirectieChange($event.value)">
                                            <mat-form-field class="px-2 w-100 sticky-input">
                                                <input matInput [formControl]="directiiControl"
                                                    (keydown)="$event.stopPropagation()"
                                                    (click)="$event.stopPropagation()" />
                                            </mat-form-field>

                                            <mat-option *ngIf="filteredDirectii.length === 0" disabled>
                                                <span>No results found</span>
                                            </mat-option>

                                            <!-- <mat-option [value]="-1">-- Alegeți --</mat-option> -->
                                            <mat-option *ngFor="let directie of filteredDirectii" [value]="directie.id">
                                                {{ directie.name }}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-md-12">
                                    <mat-form-field appearance="fill">
                                        <mat-label>Compartiment/Departament</mat-label>
                                        <mat-select formControlName="id_compartiment"
                                            (openedChange)="onCompartimentSelectClosed()"
                                            (selectionChange)="onCompartimentChange($event.value)">
                                            <mat-form-field class="px-2 w-100 sticky-input">
                                                <input matInput [formControl]="compartimenteControl"
                                                    (keydown)="$event.stopPropagation()"
                                                    (click)="$event.stopPropagation()" />
                                            </mat-form-field>

                                            <mat-option *ngIf="filteredCompartimente.length === 0" disabled>
                                                <span>No results found</span>
                                            </mat-option>

                                            <mat-option [value]="-1">-- Alegeți --</mat-option>

                                            <mat-option *ngFor="let compartiment of filteredCompartimente"
                                                [value]="compartiment.id">
                                                {{ compartiment.name }}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-md-12">
                                    <mat-form-field appearance="fill">
                                        <mat-label>Operator</mat-label>
                                        <mat-select (openedChange)="onUsersSelectClosed()" formControlName="user">
                                            <mat-form-field class="px-2 w-100 sticky-input">
                                                <input matInput [formControl]="usersControl"
                                                    (keydown)="$event.stopPropagation()"
                                                    (click)="$event.stopPropagation()" />
                                            </mat-form-field>

                                            <mat-option *ngIf="filteredUsers.length === 0" disabled>
                                                <span>No results found</span>
                                            </mat-option>

                                            <mat-option [value]="-1">-- Alegeți --</mat-option>
                                            <mat-option *ngFor="let user of filteredUsers" [value]="user.id">
                                                {{ user.name }}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                            </div>

                        </form>

                        <div class="row w-100">
                            <div class="col d-flex justify-content-start">
                                <button (click)="toggleCard()" type="button"
                                    class="btn btn-sm btn-warning closeBtn">Închide</button>
                            </div>
                            <div class="col buttons-submit">
                                <button (click)="resetForm()" type="button" class="btn btn-sm btn-secondary">
                                    Resetează
                                </button>
                                <button (click)="applyFilters()" type="submit" class="btn btn-sm btn-primary ms-2">
                                    Aplică
                                </button>
                            </div>
                        </div>
                    </div>

                    <div class="row d-flex p-2">
                        <div class="col d-flex justify-content-start align-items-center">
                            <button class="action-button d-flex align-items-center" (click)="toggleCard()"
                                [class.active]="showCard">
                                <img src="assets/images/filter-icon.png" alt="" />
                                <span>Filtre</span>
                            </button>
                        </div>

                        <div class="col d-flex justify-content-end">
                            <button type="button" class="btn btn-light action-button" [popover]="popTemplate"
                                [adaptivePosition]="true" container="body" boundariesElement="viewport"
                                placement="left">
                                <img src="assets/icons/calendar-icon.svg" alt="Calendar" />
                                <span>{{ selectedStartDate | date : "dd.MM.yyyy" }} - {{ selectedEndDate | date :
                                    "dd.MM.yyyy"
                                    }}
                                </span>
                            </button>

                            <!-- Popover Template below-->
                            <ng-template #popTemplate>
                                <div class="popover">
                                    <div class="row">
                                        <div class="col d-flex justify-content-between">
                                            <h2>Selectați intervalul</h2>
                                            <button style="height: 40px; width: 100px" class="btn btn-light close-btn"
                                                (click)="closePopover()">
                                                <img src="assets/icons/close.svg" alt="Închide"
                                                    style="height: 20px; width: 20px" />
                                                <span class="close-text">ÎNCHIDE</span>
                                            </button>
                                        </div>
                                    </div>
                                    <div class="row mt-2 mb-2">
                                        <div class="col d-flex justify-content-between responsive-filters">
                                            <button type="button" class="action-button" [class.selected]="
                                                    selectedFilteringButton === 'last_0_days'
                                                    " (click)="setLastXDays(0)">
                                                <span>AZI</span>
                                            </button>
                                            <button type="button" class="action-button" [class.selected]="
                                                    selectedFilteringButton === 'last_7_days'
                                                    " (click)="setLastXDays(7)">
                                                <span>7 ZILE</span>
                                            </button>
                                            <button type="button" class="action-button" [class.selected]="
                                                    selectedFilteringButton === 'last_30_days'
                                                    " (click)="setLastXDays(30)">
                                                <span>30 ZILE</span>
                                            </button>
                                            <button type="button" class="action-button" [class.selected]="
                                                    selectedFilteringButton === 'current_year'
                                                    " (click)="setYear(0)">
                                                <span>AN CURENT</span>
                                            </button>
                                            <button type="button" class="action-button" [class.selected]="
                                                    selectedFilteringButton === 'previous_year'
                                                    " (click)="setYear(1)">
                                                <span>AN ANTERIOR</span>
                                            </button>
                                        </div>
                                    </div>
                                    <div class="datepicker-container">
                                        <div class="col">
                                            <div class="datepicker-header">
                                                <div class="text">DE LA:</div>
                                                <div class="date">
                                                    {{ selectedStartDate | date : "mediumDate" }}
                                                </div>
                                            </div>
                                            <mat-card>
                                                <mat-calendar #startCalendar [(selected)]="selectedStartDate"
                                                    [startAt]="selectedStartDate" [maxDate]="today"
                                                    [maxDate]="selectedEndDate"
                                                    (selectedChange)="rerenderDT()"></mat-calendar>
                                            </mat-card>
                                        </div>
                                        <div class="col">
                                            <div class="datepicker-header">
                                                <div class="text">PÂNĂ LA:</div>
                                                <div class="date">
                                                    {{ selectedEndDate | date : "mediumDate" }}
                                                </div>
                                            </div>
                                            <mat-card>
                                                <mat-calendar #endCalendar [(selected)]="selectedEndDate"
                                                    [maxDate]="today" (selectedChange)="rerenderDT()"></mat-calendar>
                                            </mat-card>
                                        </div>
                                    </div>
                                </div>
                            </ng-template>
                        </div>
                    </div>
                    <div class="table-container">
                        <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" class="row-border hover w-100">
                        </table>
                    </div>
                    <div class="section-spinner position-absolute" *ngIf="isLoading">
                        <div class="spinner position-absolute top-50 start-50 translate-middle">
                            <mat-spinner></mat-spinner>
                            <h3 class="mt-2">{{ helper.dialogConfig.generalMessages.pleaseWait }}</h3>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>